import type { FeatureMiddleware } from '@cast/api-client';
import {
  demoEdgeLocationsList,
  demoOmniEnabledClusterList,
} from '@cast/fixtures';

import { getIsClusterDemoMode } from '@cast/infrastructure-demo';

export const omni: FeatureMiddleware<'omni'> = {
  listEdgeLocations: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoEdgeLocationsList();
      return resolve(fixture);
    }
    return next();
  },
  listClusters: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoOmniEnabledClusterList();
      return resolve(fixture);
    }
    return next();
  },
};
